import { createSelector } from 'reselect';
import { LIGHTWEIGHT_FILTERS_ANALYTICS } from '../../../../../../shared/constants/flipperFlags';
import { LIGHTWEIGHT_FILTERS_NAMESPACES_WHITELIST } from '../../../../../../shared/constants/lightweightFilters';
import { ShareableData, SingleNamespaceData } from '../../../../common/types/shareableTypes';
import { isFeatureEnabled } from '../../../../main/selectors/FlipperSelectors';
import { CONTEXTS } from './LightweightFilters.constants';
import { Query } from './Filters/Filters.types';

const selectShareableData: (state: any) => ShareableData = createSelector(
  (state: any): ShareableData => state.shareable.data,
  (shareableData): ShareableData => shareableData || {}
);

export const selectShareableDataByNamespace: (state: any, namespace: string) => SingleNamespaceData = createSelector(
  selectShareableData,
  (state: any, namespace: string): string => namespace,
  (shareableData, namespace): SingleNamespaceData => shareableData[namespace] || {}
);

export const selectShareableDataByNamespaceAndContext: (state: any, namespace: string) => any = createSelector(
  selectShareableDataByNamespace,
  (state: any, namespace: string): string => CONTEXTS[namespace].table,
  (shareableDataByNamespace, context): any => shareableDataByNamespace[context] || {}
);

export const selectCheckboxesValues: (state: any, namespace: string) => [boolean, boolean] = createSelector(
  selectShareableDataByNamespaceAndContext,
  (shareableDataByContext): [boolean, boolean] => [!!shareableDataByContext.organic, !!shareableDataByContext.unique]
);

export const selectSplitSkanCheckboxValue: (state: any, namespace: string) => boolean = createSelector(
  selectShareableDataByNamespace,
  (shareableDataByNamespace): boolean => !!shareableDataByNamespace.splitSkanData
);

export const selectQueryValue: (state: any, namespace: string) => Query = createSelector(
  selectShareableDataByNamespaceAndContext,
  (shareableDataByContext): Query => shareableDataByContext.query || {}
);

export const selectRunFullReport: (state: any, namespace: string) => boolean = createSelector(
  selectShareableDataByNamespaceAndContext,
  (shareableDataByContext): boolean => !!shareableDataByContext.runFullReport
);

export const selectLightweightFiltersEnabled: (state: any, namespace: string) => boolean = createSelector(
  (state: any): boolean => isFeatureEnabled(state, LIGHTWEIGHT_FILTERS_ANALYTICS),
  (state: any, namespace: string): boolean => LIGHTWEIGHT_FILTERS_NAMESPACES_WHITELIST.includes(namespace),
  (isFlipperEnabled: boolean, isWhitelisted: boolean): boolean => isFlipperEnabled && isWhitelisted
);
